export default __webpack_public_path__ + "static/media/home_fourth_section_right.c5cda5f8.png";